import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export default function PageHero({
  title,
  description,
  image,
  imageAlt,
  showCta = true,
  eyebrow,
  actions,
}) {
  const navigate = useNavigate()

  const cta = actions ?? (
    showCta ? (
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <Button size="lg" onClick={() => navigate('/onboarding')}>
          Get Started
        </Button>
        <Button size="lg" variant="outline" onClick={() => navigate('/pricing')}>
          View Pricing
        </Button>
      </div>
    ) : null
  )

  if (!image) {
    return (
      <section className="bg-gradient-to-br from-slate-50 to-white py-16 md:py-24">
        <div className="container mx-auto max-w-7xl px-6">
          <div className="mx-auto max-w-3xl text-center">
            {eyebrow && (
              <p className="mb-4 text-sm font-semibold uppercase tracking-widest text-primary">
                {eyebrow}
              </p>
            )}
            <h1 className="mb-6 text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl md:text-6xl">
              {title}
            </h1>
            {description && (
              <p className="mb-8 text-xl leading-relaxed text-slate-600">
                {description}
              </p>
            )}
            {cta && <div className="flex justify-center">{cta}</div>}
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="relative min-h-[min(70vh,42rem)] overflow-hidden bg-slate-50 md:min-h-[min(75vh,48rem)]">
      <img
        src={image}
        alt={imageAlt || title}
        className="absolute inset-0 h-full w-full object-cover object-[70%_center]"
      />
      <div
        className="absolute inset-0 bg-gradient-to-r from-white from-0% via-white/92 via-[42%] to-transparent to-[78%]"
        aria-hidden="true"
      />
      <div className="relative container mx-auto flex min-h-[min(70vh,42rem)] max-w-7xl items-center px-6 py-16 md:min-h-[min(75vh,48rem)] md:py-24">
        <div className="max-w-xl text-left lg:max-w-2xl">
          {eyebrow && (
            <p className="mb-4 text-sm font-semibold uppercase tracking-widest text-primary">
              {eyebrow}
            </p>
          )}
          <h1 className="mb-6 text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl md:text-6xl">
            {title}
          </h1>
          {description && (
            <p className="mb-10 max-w-xl text-lg leading-relaxed text-slate-600 md:text-xl">
              {description}
            </p>
          )}
          {cta}
        </div>
      </div>
    </section>
  )
}
